import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bg1 from "../assets/img/bg.jpg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { useAppKitAccount } from "@reown/appkit/react";
import { useToken } from "../components/TokenContext";
import {
  loginWithWallet,
  directLogin,registerWithAPIWallet
} from "../api/apiService";
import AlertMessage from "../components/AlertMessage";
import AuthLayout from "../components/Layout/AuthLayout";

const Login = () => {
  const [loginToken, setLoginToken] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const { address } = useAppKitAccount();
  const { token, fetchToken } = useToken();

  const [loading, setLoading] = useState(false);
  const [reactalert, setAlert] = useState({ type: "", message: "" });



  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const LoginToken = params.get("LoginToken");
    if (LoginToken) setLoginToken(LoginToken);
  }, [location.search]);

  useEffect(() => {
    if (loginToken) handleDirectLogin(loginToken);
  }, [loginToken]);

useEffect(() => {
    const initialize = async () => {
      try {
        let currentToken = token || (await fetchToken());
        if (!currentToken) return;

        // Only register if wallet is connected
        if (address) {  
          const data = await registerWithAPIWallet(token,address);          
        }
      } catch (err) {
   
      } finally {
        setLoading(false);
      }
    };

    initialize();
  }, [address, token, fetchToken]);

  const handleDirectLogin = async (tokenFromQuery) => {
    setLoading(true);
    try {
      let currentToken = token || (await fetchToken());
      if (!currentToken) return;

      const data = await directLogin(currentToken, tokenFromQuery);
      if (data?.status && data?.data.toLowerCase() === "login successful") {
        localStorage.setItem("LoginToken", data.LoginToken);
        const userData = data?.DataList?.[0];
        localStorage.setItem("email", userData.PERSONAEMAILID);
        localStorage.setItem("wallet", userData.WALLETADDRESS);
        localStorage.setItem("Loginid", userData.LOGINID);
        localStorage.setItem("Username", userData.USERNAME);
        navigate("/dashboard");
      } else {
        setAlert({ type: "error", message: data?.data || "Login failed!" });
      }
    } catch {
      setAlert({ type: "error", message: "Something went wrong while logging in." });
    } finally {
      setLoading(false);
    }
  };
  const handleWalletSubmit = async (e) => {
    e.preventDefault();
    let currentToken = token || (await fetchToken());
    if (!currentToken) return;

    if (!address) {
      setAlert({ type: "error", message: "Please connect your wallet first!" });
      return;
    }

    try {
      const data = await loginWithWallet(currentToken, address);      
      if (data?.status && data?.data.toLowerCase() === "login successful") {
        localStorage.setItem("LoginToken", data.LoginToken);
          const userData = data?.DataList?.[0];
        localStorage.setItem("wallet", address);
        localStorage.setItem("email", userData.PERSONAEMAILID);
        localStorage.setItem("Loginid", userData.LOGINID);
        localStorage.setItem("Username", userData.USERNAME);
        navigate("/dashboard");
      } else {
        setAlert({ type: "error", message: data?.data || "Login failed!" });
      }
    } catch {
      setAlert({ type: "error", message: "Something went wrong while logging in." });
    }
  };
  return (
    <AuthLayout loading={loading}>
      <img src={bg1} alt="" className="bg-login" />
      <span className="game_bg_1"></span>
      <span className="game_bg_2"></span>
      <span className="game_bg_3"></span>
      <span className="game_bg_4"></span>

      <div className="login-5">
        <div className="card-login">
          <div className="logo-wrp">
            <img src={logo} alt="" className="logo-pic" />
            {/* <h3 className="text-white">Hi, Welcome Back! 👋</h3> */}
            <h5 className="text-white">Sign Into Your Account</h5>
          </div>
                <form onSubmit={handleWalletSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Wallet Address</label>
                    <div className="icon-with-wallet">
                      <w3m-button />
                    </div>
                  </div>

                  {reactalert.message && (
                    <AlertMessage
                      type={reactalert.type}
                      message={reactalert.message}
                      onClose={() => setAlert({ type: "", message: "" })}
                    />
                  )}

                  <button type="submit" className="button-animation">
                    <span>Sign In</span>
                  </button>
                </form>
           

          <div className="register-bottom">
            <div className="or-text">
              <span>Or</span>
            </div>
            <div className="link-rg">
              Don’t have an account?{" "}
              <Link to="/register" className="ms-2">
                Register here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
